// eslint-disable
// this is an auto generated file. This will be overwritten

export const createDiscussion = `mutation CreateDiscussion($input: DiscussionInput!) {
  createDiscussion(input: $input) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    analysis
    annotations {
      id
      begin
      end
      label
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
export const updateDiscussion = `mutation UpdateDiscussion($input: DiscussionInput!) {
  updateDiscussion(input: $input) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    analysis
    annotations {
      id
      begin
      end
      label
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
export const deleteDiscussion = `mutation DeleteDiscussion($id: ID!) {
  deleteDiscussion(id: $id) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    analysis
    annotations {
      id
      begin
      end
      label
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
export const create = `mutation Create($input: [CreateInput]) {
  create(input: $input) {
    error
    result
  }
}
`
export const update = `mutation Update($input: DiscussionInput!) {
  update(input: $input) {
    error
    result
  }
}
`
export const analyze = `mutation Analyze($id: ID!) {
  analyze(id: $id) {
    error
    result
  }
}
`
export const del = `mutation Del($input: [ID!]) {
  del(input: $input) {
    error
    result
  }
}
`
